var _defs, _path, _path2, _rect, _rect2, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadNfs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 23.4 24.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666b70;stroke-width:0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "cls-1",
    d: "M1 0 L16 0 L22.4 6 L22.4 24.1 L1 24.1 Z M2.2 1.2 L15.2 1.2 L21.2 6.2 L21.2 22.9 L2.2 22.9 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.2 1.2 L21.2 6.2 L15.2 6.2 Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.8,
    y: 8.5,
    width: 11,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.8,
    y: 10.6,
    width: 8,
    height: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 11.7,
    y: 18,
    textAnchor: "middle",
    fontFamily: "Arial,Helvetica,sans-serif",
    fontSize: 6.5,
    fontWeight: "bold",
    fill: "#666b70"
  }, "NF-e")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNfs);
export default __webpack_public_path__ + "static/media/DownloadNFS.c5c91bb97542e2984fcc0b318e312242.svg";
export { ForwardRef as ReactComponent };